<template>
  <v-container>
    <v-row v-for="(q, i) in qas" :key="i">
      <v-col cols="11">
        <v-card class="q" color="#dfdfdf">
          <v-card-title>{{ q.title }}</v-card-title>
          <v-card-subtitle>{{ q.author }}</v-card-subtitle>
          <v-card-text>{{ q.body }}</v-card-text>
          <v-card-actions v-if="canDelete">
            {{ q.createdAt | datetime }}
            <v-spacer></v-spacer>
            <v-btn dark @click="delQuestion(q.id)" color="primary">{{ $t("common.actions.delete") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-alert v-if="qas.length == 0" type="warning" border="left" outlined>
      <h3>No questions</h3>
    </v-alert>
  </v-container>
</template>

<script>
import axios from "axios";

import { formatMixin, formMixin, listMixin } from "@/helpers/mixins";

export default {
  name: "questionlist",

  mixins: [formatMixin, formMixin, listMixin],

  data() {
    return {};
  },

  props: {
    qas: {
      type: Array,
    },
    canDelete: {
      type: Boolean,
    },
    type: {
      type: String,
      default: "question",
    },
    onChange: {
      type: Function,
    },
  },
  mounted() {},
  methods: {
    delQuestion: function(id) {
      axios
        .delete(`/api/questions/${id}`)
        .then(() => {
          this.qas = this.qas.filter((q) => q.id != id);
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped></style>
